import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-46dfe929"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  role: "tabpanel",
  class: "tab-pane col-sm-12",
  id: "settings"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Settings", -1))
const _hoisted_3 = { style: {"margin":"2rem 0"} }
const _hoisted_4 = { class: "input-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Custom Framework "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("(will override any team level framework)")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "input-wrapper"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Display custom values to viewpoints respondents", -1))
const _hoisted_9 = { class: "switch" }
const _hoisted_10 = ["checked"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_14 = {
  key: 0,
  class: "text-success"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-ok" }, null, -1))
const _hoisted_16 = {
  key: 1,
  class: "error-message"
}

import { ref, watchEffect } from "vue";
import SubmitButton from "../../submit-button.vue";
import CmsSelect from "../../cms/cms-select.vue";
import { CustomFrameworkForOrganisationsApiModel } from "../../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'settings-tab',
  props: {
    frameworkModel: {},
    settingsUpdateIsLoading: { type: Boolean },
    settingsUpdatedSuccess: { type: Boolean }
  },
  emits: ["save-settings"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const updatedFrameworkModel = ref<CustomFrameworkForOrganisationsApiModel>(
  props.frameworkModel ?? {
    customFrameworkId: "",
    isViewpoints: false,
  },
);

watchEffect(() => {
  updatedFrameworkModel.value = props.frameworkModel;
});

const onSelectEvent = (id: string): void => {
  updatedFrameworkModel.value.customFrameworkId = id;
};

const onToggleEvent = (): void => {
  updatedFrameworkModel.value.isViewpoints = !updatedFrameworkModel.value.isViewpoints;
};

const saveSettings = (): void => {
  emit("save-settings", updatedFrameworkModel.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_ctx.frameworkModel)
          ? (_openBlock(), _createBlock(CmsSelect, {
              key: 0,
              initial: _ctx.frameworkModel.customFrameworkId || '',
              type: "cms-custom-strength-mapping",
              onOnSelectionEvent: onSelectEvent
            }, null, 8, ["initial"]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_6,
      (_ctx.frameworkModel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("label", _hoisted_9, [
              _createElementVNode("input", {
                type: "checkbox",
                onChange: onToggleEvent,
                checked: updatedFrameworkModel.value.isViewpoints
              }, null, 40, _hoisted_10),
              _hoisted_11
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_12
    ]),
    _createVNode(SubmitButton, {
      style: {"width":"90px"},
      onClick: saveSettings,
      "is-submitted": _ctx.settingsUpdateIsLoading,
      "button-class": "btn-default",
      "use-recaptcha": false,
      disabled: _ctx.settingsUpdateIsLoading
    }, {
      default: _withCtx(() => [
        _createTextVNode("Save ")
      ]),
      _: 1
    }, 8, ["is-submitted", "disabled"]),
    _hoisted_13,
    (_ctx.settingsUpdatedSuccess)
      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
          _createTextVNode(" Settings saved "),
          _hoisted_15
        ]))
      : (_ctx.settingsUpdatedSuccess === false)
        ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Something went wrong, please refresh the page! "))
        : _createCommentVNode("", true)
  ]))
}
}

})